import type { IntakeSummary } from './types';

/** Completed document history, not a claim that files reflect later answer edits. */
export function intakeStatusLabel(intake: Pick<IntakeSummary, 'status' | 'hasPdf' | 'hasDoc'>): string {
	const documents = [intake.hasPdf ? 'pdf' : '', intake.hasDoc ? 'doc' : ''].filter(Boolean);
	if (!documents.length) return intake.status.replaceAll('_', ' ');
	const created = `${documents.join(', ')} created`;
	return intake.status === 'archived' ? `archived · ${created}` : created;
}
